"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAriaModal = _interopRequireDefault(require("react-aria-modal"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _getWindow = _interopRequireDefault(require("@mapbox/mr-ui/utils/get-window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.setDialogEl = _this.setDialogEl.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.dialogEl || typeof window === 'undefined') return;
      this.scrollTimeout = (0, _getWindow.default)().setTimeout(function () {
        var offsetParent = _this2.dialogEl.offsetParent;

        if (offsetParent.tagName === 'BODY' || offsetParent.tagName === 'HTML') {
          return;
        }

        offsetParent.scrollTop = 0;
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window === 'undefined') return;
      (0, _getWindow.default)().clearTimeout(this.scrollTimeout);
    }
  }, {
    key: "setDialogEl",
    value: function setDialogEl(el) {
      this.dialogEl = el;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var closeButton = null;

      if (props.onExit) {
        closeButton = /*#__PURE__*/_react.default.createElement("div", {
          className: "absolute top right mt12"
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn btn--white color-gray mr6",
          onClick: props.onExit,
          "data-test": "modal-close"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "close",
          size: 24
        })));
      }

      var dialogBody = /*#__PURE__*/_react.default.createElement("div", {
        ref: this.setDialogEl,
        className: "relative wmax-full w600 bg-white round px0 py0"
      }, props.children, closeButton);

      var modalProps = {
        titleText: props.accessibleTitle,
        getApplicationNode: props.getApplicationNode,
        underlayProps: {
          'data-popover-ignore-clicks': true
        },
        underlayClass: 'bg-darken50 px12 py12 px60-mm py60-mm ',
        underlayStyle: {
          zIndex: 4
        }
      };

      if (props.onExit) {
        modalProps.onExit = props.onExit;
      }

      if (props.initialFocus) {
        modalProps.initialFocus = props.initialFocus;
      } else {
        modalProps.focusDialog = true;
      }

      return /*#__PURE__*/_react.default.createElement(_reactAriaModal.default, modalProps, dialogBody);
    }
  }]);

  return Modal;
}(_react.default.Component);

exports.default = Modal;
Modal.propTypes = {
  accessibleTitle: _propTypes.default.string.isRequired,
  onExit: _propTypes.default.func,
  getApplicationNode: _propTypes.default.func,
  initialFocus: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
Modal.defaultProps = {
  getApplicationNode: function getApplicationNode() {
    return document.getElementById('app');
  }
};